module.exports = __webpack_public_path__ + "static/img/ARAS600_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAS600_1.png
// module id = ceuO
// module chunks = 0